<template>
  <div>
    <v-data-table :headers="headers" :items="listNotes" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon @click="deleteItem(item)" >delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
        <v-btn @click="gotoCreate" color="red" fab small dark fixed bottom justify-center>
          <v-icon >add</v-icon>
        </v-btn>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: 'ListNotes',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Nota',
          align: 'center',
          value: 'message',
          sortable: true,
        },
        {
          text: 'Data',
          align: 'center',
          value: 'date',
          sortable: true,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('notes/getNotes', this.$route.params.clientId);
  },
  computed: {
    listNotes() {
      return this.$store.state.notes.all;
    },
  },
  methods: {
    gotoCreate() {
      this.$router.push({ path: `/clients/${this.$route.params.clientId}/notes/create` });
    },
    editItem(item) {
      this.$router.push({ path: `/clients/${this.$route.params.clientId}/notes/${item.id}` });
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('notes/delete', {
          clientId: this.$route.params.clientId,
          noteId: item.id,
        });
      }
    },
  },
};
</script>
